import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';

// ----------------------------------------------------------------------

const createSensorModel = async (name: string, model: string, waterQualityItem: string, unit: string, alarmType: string, alarmLowerLimit: number, alarmUpperLimit: number) => {
  return await axios.post('water-quality-sensor-model', {waterQualityItem, name, model, unit, alarmType, alarmLowerLimit, alarmUpperLimit})
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(error);
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default createSensorModel;